<button
  (click)="clicked.emit($event)"
  [attr.data-testid]="dataTestId()"
  [attr.type]="type()"
  [disabled]="isDisabled()"
  [matTooltipPosition]="tooltipPosition()"
  [matTooltip]="tooltip()"
  [class]="{
    'branding-button': true,
    'branding-primary': isPrimary(),
    disabled: isDisabled(),
    collapsed: collapsed()
  }"
  [style.width]="customWidth()"
  [style.cursor]="'pointer'">
  <ng-content></ng-content>
  @if (text() && !collapsed()) {
    <span class="button-text">{{ text() }}</span>
  }
</button>
